// @mui
import { Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

interface Props {
	title: string;
	text?: string;
}

export function TableLink(props: Props) {
	const theme = useTheme();
	return (
		<Typography
			sx={{ cursor: 'pointer', textDecoration: 'underline' }}
			color={theme.palette.primary.main}
			variant="body1"
		>
			{props.title}
		</Typography>
	);
}

export const CustomLink = styled('span')((props) => ({
	color: props.theme.palette.root.basicDeeoGreen,
	textDecoration: 'underline',
	cursor: 'pointer',
}));

export function ErrorMessage({ children }) {
	const theme = useTheme();
	return (
		<Typography
			sx={{
				marginTop: '20px!important',
				color: theme.palette.error.main,
			}}
		>
			{children}
		</Typography>
	);
}
